import User from "./user";
import AsinzenApi from "./asinzen-api";
import WholesalesSuppliers from "./wholesales-suppliers";

export { User, AsinzenApi, WholesalesSuppliers };
export default { User, AsinzenApi, WholesalesSuppliers };
